import {addQueryParamsToURL} from '../../utils/url'
import {DatoCmsGifPipe} from '../../../shared/pipes/datocms.pipe'

export function transformDatocmsImageUrl(imageSrc: string, args?: {width?: number}) {
  // https://www.datocms.com/features/images-api
  // basically a wrapper around imgix
  const parameters: Record<string, string | number> = {
    ...(args?.width ? {w: args.width} : {}),
    // If we get a gif from DatoCMS, we want to use jpg as a format to get better SEO performance
    ...(new DatoCmsGifPipe().transform(imageSrc)
      ? {
          fm: 'jpg',
          auto: 'compress',
        }
      : {
          auto: 'format,compress',
        }),
  }
  return addQueryParamsToURL(imageSrc, parameters)
}
